const ahoy = require("packs/javascripts/vendor/ahoy");

ahoy.configure({
  urlPrefix: "/chapo",
  visitsUrl: "/visits",
  eventsUrl: "/events",
  cookies: true,
  cookieDomain: window.location.hostname.endsWith("busypaws.app") ? "busypaws.app" : null,
  page: null,
  platform: "Web",
  trackVisits: true
});

document.addEventListener("turbolinks:load", () => {
  ahoy.trackView();
});

ahoy.trackClicks("a, button, input[type=submit]");
ahoy.trackSubmits("form");

window.ahoy = ahoy;
